import { Dispatch } from 'redux';

import { OnboardingStatus } from 'src/entities/OnboardingStatus';
import { improvedOnboardingApi } from 'src/services/api/improvedOnboardingApi';
import { AppThunkAction } from 'src/store';
import { setTrialState } from 'src/store/user/actions';

export const OnboardingTaskStatusHandler =
  (onboardingStatuses: OnboardingStatus): AppThunkAction =>
  async (dispatch: Dispatch<any>, getState) => {
    const state = getState();
    const stripeSubscriptions = state.user.data?.stripeSubscriptions;
    dispatch(setTrialState(stripeSubscriptions, onboardingStatuses));

    const cachedArgs = improvedOnboardingApi.util.selectCachedArgsForQuery(
      state,
      'getOnboardingTaskStatus',
    );
    cachedArgs.forEach((args) => {
      dispatch(
        improvedOnboardingApi.util.updateQueryData(
          'getOnboardingTaskStatus',
          args,
          (onboardingStatusDraft) => {
            onboardingStatusDraft.fields = onboardingStatuses.fields;
            onboardingStatusDraft.additionalFields =
              onboardingStatuses.additionalFields;
          },
        ),
      );
    });
  };
